module.exports = __webpack_public_path__ + "img/9788995898086.5161bbf8.jpg";